var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'checkbox ' + _vm.checkboxClass},[_c('input',{attrs:{"type":_vm.inputType,"name":_vm.name,"id":_vm.id},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":function($event){return _vm.updateValue($event.target)}}}),_c('span',{staticClass:"checkbox-handle"})])
}
var staticRenderFns = []

export { render, staticRenderFns }